/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState, useRef, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, Modal, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import '../multi-industry/index.scss';
import './index.scss';
import Color from '@tool/color';
import { CloseIcon20, CloseIcon } from '@styled/icon';
import {
  DButton, EButton, SureButton, ChooseButton,
} from '../../../../component/styled/index';
import moIndex, {
  changeBaseCity, toggleCityModal,
} from '../../store/index';

interface IProps {}
interface IState {}

const DModal = styled(Modal)(() => ({
  zIndex: 5555555,
}));

const CloseIconButton = styled(IconButton)(() => ({}));

const BaseCity = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const subRef = useRef(null);
  const {
    baseCity, cityList, cityModal,
  } = moIndex;

  useEffect(() => {
    return () => {};
  }, []);

  const onNothing = () => {};

  return (
    <DModal open={cityModal} onClose={() => onNothing()}>
      <section className="base-city_111 industry-modal_0110">
        <section className="title-015" style={{ paddingRight: '20px' }}>
          <span>选择城市</span>
          <CloseIconButton onClick={() => toggleCityModal(false)}>
            <CloseIcon20 color={Color.blackColor(0.65)} />
          </CloseIconButton>
        </section>
        <section className="modal-0111">
          <section className="industry-0201" style={{ padding: 0 }}>
            {cityList?.map((item: any, index: number) => (
              <section key={index} className="item-111">
                <EButton key={index}
                  onClick={() => changeBaseCity(item.code, item.name)}
                  className={item.active ? 'active' : ''}>{item.name}
                </EButton>
              </section>
            ))}
          </section>
        </section>
      </section>
    </DModal>
  );
};

export default observer(BaseCity);
